import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
// import SwitchComponent from "../../../../components/hookForms/switch";
import RadioButton from "../../../../components/hookForms/radioButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceFaturaConcessionaria from "../../../../services/serviceFaturaConcessionaria";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        id: string;
        saldoAtual: string;
        energiaInjetada: string;
        consumoKWH: string;
        dataVencimento: Date;
        flagDebitoAutomatico: string;
        tarifaKWH: string;
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        saldoAtual: yup.string().required(messages.requiredField),
        energiaInjetada: yup.string().required(messages.requiredField),
        consumoKWH: yup.string().required(messages.requiredField),
        dataVencimento: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        flagDebitoAutomatico: yup.string().required(messages.requiredField),
        tarifaKWH: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            saldoAtual: "",
            energiaInjetada: "",
            consumoKWH: "",
            dataVencimento: new Date(),
            flagDebitoAutomatico: "",
            tarifaKWH: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);
        const updateValues = {
            ...values,
            faturaConcessionariaID: data.id,
            ValorKWH: values.tarifaKWH ? Number(values.tarifaKWH.replaceAll(".", "").replaceAll(",", ".")) : 0,
            saldoAtual: values.saldoAtual ? Number(values.saldoAtual.replaceAll(".", "").replaceAll(",", ".")) : 0,
            energiaInjetada: values.energiaInjetada
                ? Number(values.energiaInjetada.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            consumoKWH: values.consumoKWH ? Number(values.consumoKWH.replaceAll(".", "").replaceAll(",", ".")) : 0,
            dataVencimento: values.dataVencimento ? format(new Date(values.dataVencimento), "yyyy-MM-dd") : "",
            flagDebitoAutomatico: values.flagDebitoAutomatico.toLowerCase() === "sim" ? "Sim" : "Não",
        };

        serviceFaturaConcessionaria
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const onCancelEdit = () => {
        reset();
        onClose(true);
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar Fatura
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelEdit();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="saldoAtual"
                                label="Saldo"
                                control={control}
                                error={errors}
                                decimalScale={8}
                                maxLength={24}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="energiaInjetada"
                                label="Injeção"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={9}
                                noThousandSeparator
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="consumoKWH"
                                label="Consumo"
                                control={control}
                                error={errors}
                                decimalScale={0}
                                maxLength={9}
                                noThousandSeparator
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="tarifaKWH"
                                label="Valor kWh"
                                control={control}
                                decimalScale={8}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <DatePickerMui
                                name="dataVencimento"
                                label="Data de Vencimento"
                                control={control}
                                error={errors}
                                noDateForward={false}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <RadioButton
                                name="flagDebitoAutomatico"
                                title="Débito Automático"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => onCancelEdit()}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
